import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import type { ComponentProps } from 'react';
import { LogoFull } from '../nav/LogoFull';
import './signin.css';

/**
 * Branded sign-in splash. The stock SignInPage (same component the default
 * app extension uses) is mounted inside the white panel and restyled by
 * signin.css; everything around it is the brand composition described there.
 * Microsoft Entra ID is the only provider — the guest fallback was removed
 * 2026-08-05 after SSO was verified end-to-end.
 */
const CleverSignInPage = (props: object) => (
  <div className="clever-splash">
    <main className="clever-splash-panel">
      <div className="clever-splash-logo">
        <LogoFull />
      </div>
      <div className="clever-splash-rule" aria-hidden="true" />
      <h1 className="clever-splash-title">Application Portfolio Management</h1>
      <div className="clever-splash-signin">
        <SignInPage
          {...(props as ComponentProps<typeof SignInPage>)}
          providers={[
            {
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'Sign in with your Clever Platform account',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      </div>
    </main>
    <p className="clever-splash-foot">CLEVER PLATFORM&ensp;&middot;&ensp;JEDDAH, KSA</p>
  </div>
);

const cleverSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <CleverSignInPage {...props} />,
  },
});

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cleverSignInPage],
});
